<template>
  <div class="DL">
    <section-header heading="2" ja="アプリでプリクラをダウンロード"/>
    <div class="text-area">
      下のボタンからアプリをダウンロード！<br>
      アプリでログインしたら、プリダウンロードから<br>
      シールのQRを読み込んでね♪
    </div>
    <div class="storeLink">
      <a href="https://apps.apple.com/jp/app/%E3%83%97%E3%83%AA%E3%82%AF%E3%83%A9on/id1491707486?l=en&amp;itsct=apps_box&amp;itscg=30200" style="display: inline-block; overflow: hidden; border-radius: 13px; width: 160px; height: 71px; padding: 11px; vertical-align: top;"><img src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/ja-JP?size=250x83&amp;releaseDate=1601942400&h=fd01c540f4b59e9b14385d0f0471c6f8" alt="Download on the App Store" style="border-radius: 13px; width: 140px; height: 49px;"></a>
      <a href='https://play.google.com/store/apps/details?id=com.sega.puri&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img alt='Google Play で手に入れよう' src='https://play.google.com/intl/en_us/badges/static/images/badges/ja_badge_web_generic.png' style="height: 70px;" /></a>
    </div>

    <section-header heading="2" ja="WEBでダウンロードする場合はこちら"/>
    <template v-if="!isLogin">
      <div class="text-area">
        WEBでダウンロードする場合は、下のボタンからプリクラONにログインしてね！
      </div>
      <div class="text-area">
        ※WEBでは落書き/メイク/背景なしは保存できません。<br>
        アプリでのみ保存できます。
      </div>
      <normal-btn @click="onLogin">ログイン</normal-btn>
    </template>
    <template v-if="isLogin">
      <div class="text-area">
        WEBでダウンロードする場合は、下のボタンを押してね！
      </div>
      <div class="text-area">
        ※WEBでは落書き/メイク/背景なしは保存できません。<br>
        アプリでのみ保存できます。
      </div>
      <normal-btn :disabled="!isLogin" @click="downloadSheet()">プリクラをダウンロード</normal-btn>
    </template>
  </div>
</template>

<script>
import SectionHeader from '../components/SectionHeader'
import NormalBtn from '../components/NormalBtn'
import Protobuf from '../mixins/protobuf'

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web

export default {
  name: "DL",
  components: {
    NormalBtn,
    SectionHeader
  },
  mixins: [Protobuf],
  computed: {
    isLogin() {
      return this.$store.getters.isLogin
    },
    playerId() {
      return this.$route.params.playerId
    },
  },
  mounted(){
    if(this.playerId) {
      this.$router.push('/DL')
    }
  },
  methods: {
    onBack() {
        window.open('/accountRegistration1', '_blank')
    },
    onLogin() {
      this.$router.push('/login?to=/DL?s=' + this.$route.query.s)
    },
    download() {
        this.$router.push('/DlFinish')
    },
    downloadSheet() {
      const sheetId = this.$route.query.s
      const cmdNo = pb.SheetAddReq.CommandNo.COMMAND_NO
      const message = pb.SheetAddReq.create({
        id: 0,
        encSheetId: sheetId,
        reserve: true,
      })
      const encoded = pb.SheetAddReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          let dl = null;
          if(decoded.arcadeName) {
            dl = true;
          } else {
            dl = false;
          }
          switch (decoded.status) {
            case pb.SheetAddResp.Status.ALREADY_EXISTS:
              this.$_error('Error', { title: 'プリダウンロード', statusCode: 426 })
              break
            case pb.SheetAddResp.Status.ACCOUNT_MAX:
              this.$_error('Error', { title: 'プリダウンロード', statusCode: 425 })
              break
            case pb.SheetAddResp.Status.EXPIRED:
              this.$_error('Error', { title: 'プリダウンロード', statusCode: 424 })
              break
            case pb.SheetAddResp.Status.SUCCESS:
              this.$router.push({ name: 'DlFinish',
                params: {
                  download: dl,
                }
              })
              break
            default:
              this.$_error('Error', { title: 'プリダウンロード', statusCode: 420 })
              break
          }
        })
        .catch(() => {
          this.$_error('Error', { title: 'プリダウンロード', statusCode: 100 })
        })
    },
  }
}
</script>

<style scoped>
.text-area {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
}
.storeLink {
  margin: 10px 0;
  text-align: center;
}
</style>
